import ApiService from "./api.service";

class RegisterService extends ApiService {
    getSessionsForRegister() {
        return this.get(`api/meeting/register/getSessionsForRegister`);
    }

    getRegistryForSession(id) {
        return this.get(`api/meeting/register/getRegistryForSession/${id}`)
    }

    getRegisterByAttachementId(id, pointId) {
        return this.get(`api/meeting/register/getRegisterByAttachementId/${id}/${pointId}`)
    }

    saveRegister(attId, pointId, sid, data) {
        return this.post(`api/meeting/register/saveRegister/${attId}/${pointId}/${sid}`, data)
    }

    getRegister(id) {
        return this.get(`api/meeting/register/getRegister/${id}`)
    }

    updateRegister(id, pointId, data) {
        return this.post(`api/meeting/register/updateRegister/${id}/${pointId}`, data)
    }

    searchRegister(data) {
        return this.post(`api/meeting/register/search`, data)
    }

    exportRegistry(data){
        return this.post(`api/meeting/register/export`, data, { responseType: "arraybuffer" })
    }
}

export default new RegisterService();
